"use client"
// Auto-generated by boneyard vite plugin — do not edit
import { registerBones } from 'boneyard-js/react'

import _dashboard_setup_guide from './dashboard-setup-guide.bones.json'
import _dashboard from './dashboard.bones.json'
import _widget_cart_editor from './widget-cart-editor.bones.json'
import _widget_checkout_editor from './widget-checkout-editor.bones.json'
import _widget_editor from './widget-editor.bones.json'

registerBones({
  "dashboard-setup-guide": _dashboard_setup_guide,
  "dashboard": _dashboard,
  "widget-cart-editor": _widget_cart_editor,
  "widget-checkout-editor": _widget_checkout_editor,
  "widget-editor": _widget_editor,
})
